import { render } from "./PartDetails.vue?vue&type=template&id=2b4bcee7"
import script from "./PartDetails.vue?vue&type=script&lang=js"
export * from "./PartDetails.vue?vue&type=script&lang=js"
script.render = render

export default script